export const WECOM_SUITE_KEY_IMKT = "imkt";